module.exports = __webpack_public_path__ + "static/fsc_logo-c94f17b9c8a49a46d0cb5803fe7812fe.png";